import { Box, Flex, Stack, useBreakpointValue } from "@chakra-ui/react"
import CarouselButton from "@components/buttons/CarouselButton"
import { DrawbacksList } from "@data/drawbacks"
import { partitionArray } from "@utils/utils"
import Image from "next/image"
import { useTranslations } from "next-intl"
import { Carousel } from "react-responsive-carousel"

import styles from "./Drawbacks.module.css"

export default function Drawbacks() {
  const arraySize = useBreakpointValue({ base: 1, lg: 4 })
  const centerMode = useBreakpointValue({ base: true, sm: false })
  const drawbacks = partitionArray(DrawbacksList, arraySize ?? 4)
  const t = useTranslations("home.drawbacks")
  return (
    <Carousel
      ariaLabel={"Drawbacks Carousel"}
      autoPlay={false}
      emulateTouch={true}
      showArrows={true}
      showStatus={false}
      showIndicators={false}
      showThumbs={false}
      preventMovementUntilSwipeScrollTolerance={true}
      infiniteLoop={!centerMode}
      centerMode={centerMode}
      className={styles.carousel}
      renderArrowPrev={(onClickHandler, hasPrev, label) => (
        <CarouselButton
          onClick={onClickHandler}
          aria-label={label}
          direction={"prev"}
          transform={{ base: "translateY(-70px)", lg: "translateY(-25px)" }}
        />
      )}
      renderArrowNext={(onClickHandler, hasNext, label) => (
        <CarouselButton
          onClick={onClickHandler}
          aria-label={label}
          direction={"next"}
          transform={{ base: "translateY(-70px)", lg: "translateY(-25px)" }}
        />
      )}
    >
      {drawbacks.map((drawbackSlide, index) => (
        <Flex
          w={{ base: "80%", sm: "full" }}
          key={index}
          wrap={"wrap"}
          justifyContent={{ base: "flex-start", sm: "center" }}
        >
          {drawbackSlide?.map(({ image, description }, index) => (
            <Stack
              m={{ base: 0, xl: 4 }}
              flexDirection={{
                base: "column-reverse",
                lg: index % 2 === 0 ? "row" : "row-reverse",
              }}
              justifyContent={"center"}
              alignItems={{ base: "flex-start", sm: "center" }}
              key={index}
            >
              <Flex
                flexDirection={{
                  base: "row",
                  lg: index % 2 === 0 ? "row-reverse" : "row",
                }}
                width={{ base: 210, sm: "full", lg: 200, xl: 240 }}
                color={"brand.black"}
                textAlign={{
                  base: "left",
                  lg: index % 2 === 0 ? "right" : "left",
                }}
                borderStyle={"dashed"}
                borderTopWidth={{ base: 0, lg: 2 }}
                borderBottomWidth={2}
                borderColor={"brand.secondary"}
                minHeight={100}
                alignItems={"center"}
                justifyContent={{
                  base: "flex-start",
                  lg: index % 2 === 0 ? "flex-start" : "flex-end",
                }}
                fontSize={"sm"}
                m={{ base: 0, lg: 4 }}
                px={{ base: 0, lg: 4 }}
                textTransform={"capitalize"}
              >
                {t(description)}
              </Flex>
              <Box
                borderRadius={4}
                overflow={"hidden"}
                width={{ lg: 180, xl: 240 }}
                height={{ lg: 140, xl: 184 }}
                position={"relative"}
              >
                <Image
                  src={image}
                  loader={({ src }) => src}
                  width={410}
                  height={317}
                  alt={t(description)}
                  placeholder={"blur"}
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              </Box>
            </Stack>
          ))}
        </Flex>
      ))}
    </Carousel>
  )
}
